<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <h1>{{ titleKey | translate }}</h1>
    @if (dialogData && dialogData.bailiff_delivery_allowed) {
      <div
        class="mode-toggle"
        role="tablist"
      >
        <button
          type="button"
          class="mode-toggle__option"
          role="tab"
          [class.mode-toggle__option--active]="isAddAddressMode"
          [attr.aria-selected]="isAddAddressMode"
          (click)="setMode('add_address')"
        >
          {{ "WORKFLOW_DIALOGS.ADD_DELIVERY_ADDRESS.TITLE" | translate }}
        </button>
        <button
          type="button"
          class="mode-toggle__option"
          role="tab"
          [class.mode-toggle__option--active]="isBailiffDeliveryMode"
          [attr.aria-selected]="isBailiffDeliveryMode"
          (click)="setMode('bailiff_delivery')"
        >
          {{ "WORKFLOW_DIALOGS.REQUEST_BAILIFF_DELIVERY.TITLE" | translate }}
        </button>
      </div>
    }
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ descriptionKey | translate }}
    </div>
    @if (isAddAddressMode) {
      <a
        href="https://help.payee.tech/hu/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ "WORKFLOW_DIALOGS.ADD_DELIVERY_ADDRESS.NO_DATA" | translate }}
      </a>
    }
    @if (isBailiffDeliveryMode && dialogData?.delivery_fee) {
      <div class="delivery-fee">
        {{ "WORKFLOW_DIALOGS.REQUEST_BAILIFF_DELIVERY.DELIVERY_FEE" | translate }}:
        {{ dialogData?.delivery_fee?.amount | currency: dialogData?.delivery_fee?.currency_iso : "symbol-narrow" : "1.0" : "hu" }}
      </div>
    }
  </ng-template>

  <!-- Add delivery address: old address + form -->
  @if (isAddAddressMode) {
    <div
      class="old-address input-label-small"
      color="grey-medium"
    >
      <span>
        {{ "WORKFLOW_DIALOGS.ADD_DELIVERY_ADDRESS.CURRENT_INCORRECT_ADDRESS" | translate }}
        &nbsp;
        <strong>{{ dialogData?.old_address }}</strong>
      </span>
    </div>
    <payee-form-field
      width="max"
      height="taller"
    >
      <textarea
        payee-input
        [placeholder]="'WORKFLOW_DIALOGS.ADD_DELIVERY_ADDRESS.PLACEHOLDER' | translate"
        [formControl]="newAddressForm"
      ></textarea>
    </payee-form-field>
  }

  <ng-template #payeePopupSubmitTemplate>
    <!-- Bailiff delivery: payment options -->
    @if (isBailiffDeliveryMode) {
      <div class="payment-options">
        <button
          class="payee-button"
          payee-button
          color="blue"
          width="max"
          height="normal"
          [disabled]="loading"
          [loading]="loading"
          (click)="payByCard()"
        >
          {{ "WORKFLOW_DIALOGS.REQUEST_BAILIFF_DELIVERY.PAY_BY_CARD" | translate }}
        </button>
        @if (showInsufficientCreditsWarning) {
          <button
            type="button"
            class="payee-button"
            payee-button
            color="alert-green"
            width="max"
            height="normal"
            [disabled]="loading"
            (click)="closeDialogAndGoToCredits()"
          >
            {{ "WORKFLOW_DIALOGS.REQUEST_BAILIFF_DELIVERY.INSUFFICIENT_CREDITS" | translate }}
          </button>
        }
        @if (showPayWithCreditsButton) {
          <button
            class="payee-button"
            payee-button
            color="alert-green"
            width="max"
            height="normal"
            [disabled]="loading"
            [loading]="loading"
            (click)="payWithCredits()"
          >
            {{ "WORKFLOW_DIALOGS.REQUEST_BAILIFF_DELIVERY.PAY_WITH_CREDITS" | translate }}
          </button>
        }
        <button
          class="payee-button"
          payee-button
          color="white"
          width="max"
          height="normal"
          [isBorderButton]="true"
          [disabled]="loading"
          [loading]="loading"
          (click)="payByTransfer()"
        >
          {{ "WORKFLOW_DIALOGS.REQUEST_BAILIFF_DELIVERY.PAY_BY_TRANSFER" | translate }}
        </button>
      </div>
    }
    <!-- Add delivery address: submit -->
    @if (isAddAddressMode) {
      <button
        payee-button
        color="blue"
        width="max"
        height="normal"
        [disabled]="loadingAddress"
        [loading]="loadingAddress"
        (click)="submitAddress()"
      >
        {{ "WORKFLOW_DIALOGS.ADD_DELIVERY_ADDRESS.SUBMIT" | translate }}
      </button>
    }
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      class="payee-button"
      payee-button
      color="white"
      width="max"
      height="normal"
      [isBorderButton]="true"
      (click)="cancel()"
    >
      <ng-container>
        {{ cancelKey | translate }}
      </ng-container>
    </button>
  </ng-template>
</payee-popup>
